

































































































































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { parseCurrency, setValue } from 'vue-currency-input'

import { Component, Emit, Model, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

import { ListItem, VxInputGroup } from '@/layouts/components'

import { DeliverySettings, DeliverySettingsResourcePayload } from '@/models'

import { VueCurrencyOptions } from '@/vue-currency-input'

import CopyButton from './CopyButton.vue'
import SwitchListItem from './SwitchListItem.vue'
import { isFood } from '@/utils'

@Component({
  components: {
    CopyButton,
    ListItem,
    SwitchListItem,
    ValidationObserver,
    ValidationProvider,
    VxInputGroup
  }
})
export default class DeliverySettingsForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: DeliverySettingsResourcePayload | null

  @Prop({ type: Object })
  readonly deliverySettings!: DeliverySettings | null

  @Prop({ type: Number, required: true })
  readonly businessUnitId!: number

  @Prop({ type: Boolean, default: false })
  readonly isLocked!: boolean

  isValid = false
  shouldVerifySlug = false

  maskedPhone = ''
  slug = ''
  isActive = false
  maskedFee = ''

  @Ref()
  readonly feeInputRef?: Vue

  get fee () {
    return parseCurrency(this.maskedFee, this.feeOptions)
  }

  set fee (value: number) {
    this.$nextTick(() => {
      if (this.feeInputRef) {
        const input = this.feeInputRef.$el.getElementsByTagName('input')[0]
        setValue(input, value)
      }
    })
  }

  get feeOptions () {
    return {
      ...VueCurrencyOptions,
      allowNegative: false,
      valueRange: {
        min: 0,
        max: 999.99
      }
    }
  }

  get feeRules () {
    return {
      minPrice: this.feeOptions,
      maxPrice: this.feeOptions,
      required: true
    }
  }

  get cleanDeliveryBaseUrl () {
    return this.deliveryBaseUrl.replace(/(^\w+:|^)\/\//, '')
  }

  get deliveryBaseUrl () {
    return isFood()
      ? `${process.env.VUE_APP_BASE_URL_KIOSK}/`
      : `${process.env.VUE_APP_BASE_URL_KIOSK_STORE}/`
  }

  get deliveryUrl () {
    return this.deliveryBaseUrl + this.slug
  }

  get hasSlug () {
    return this.slug !== ''
  }

  get isPhoneValid () {
    return /^55\d{10,11}$/.test(this.phone)
  }

  get phone () {
    return '55' + this.maskedPhone.replace(/\D/g, '')
  }

  set phone (value: string) {
    this.maskedPhone = value.replace(/^55/, '')
  }

  get slugRules () {
    return {
      max: 20,
      excluded: [
        'app',
        'sign-in',
        'index.html',
        'robots.txt',
        'web.config'
      ],
      regex: /^[a-z0-9_-]+$/,
      verifySlug: this.shouldVerifySlug
    }
  }

  @Watch('data', { immediate: true })
  onDataChange () {
    if (this.data === null) {
      this.phone = ''
      this.slug = ''
      this.isActive = false
      this.fee = 0
    } else {
      this.phone = this.data.phone ?? ''
      this.slug = this.data.slug ?? ''
      this.isActive = this.data.active
      this.fee = this.data.fee
    }
  }

  @Watch('phone')
  onPhoneChange () {
    this.updateModel()
  }

  @Watch('slug')
  onSlugChange (val: string, old: string) {
    if (val === '') {
      this.isActive = false
    } else if (old === '' && this.isActive === false) {
      this.isActive = true
    } else {
      const lower = this.slug.toLowerCase().replace(' ', '-')

      if (lower !== this.slug) {
        this.slug = lower
      } else {
        this.updateModel()
      }
    }
  }

  @Watch('fee')
  onFeeChange () {
    this.updateModel()
  }

  @Watch('isActive')
  onIsActiveChange () {
    this.updateModel()
  }

  verifySlug () {
    if (this.deliverySettings && this.data && this.deliverySettings.slug === this.data.slug) {
      return
    }

    this.shouldVerifySlug = true
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid && this.isPhoneValid

    this.$emit('update:isValid', this.isValid)
  }

  @Emit('change')
  updateModel (): DeliverySettingsResourcePayload {
    return {
      shopId: this.businessUnitId,
      phone: this.phone !== '55'
        ? this.phone
        : null,
      slug: this.slug !== ''
        ? this.slug
        : null,
      active: this.isActive,
      fee: this.fee
    }
  }

  submit () {
    if (this.isValid) {
      this.$emit('submit')
    }
  }
}
